export function toObjectById(items, { idKey = "id", filterNull = true } = {}) {
  const list = Array.isArray(items) ? items : [];
  const pairs = [];
  for (const item of list) {
    if (!item || typeof item !== "object") continue;
    const id = item?.[idKey];
    if (filterNull && (id === null || id === undefined)) continue;
    pairs.push([id, item]);
  }
  return Object.fromEntries(pairs);
}

export function toMapById(items, { idKey = "id", filterNull = true } = {}) {
  const list = Array.isArray(items) ? items : [];
  const map = new Map();
  for (const item of list) {
    if (!item || typeof item !== "object") continue;
    const id = item?.[idKey];
    if (filterNull && (id === null || id === undefined)) continue;
    map.set(id, item);
  }
  return map;
}

export function toMapBy(items, getKey, { filterNull = true } = {}) {
  const list = Array.isArray(items) ? items : [];
  const map = new Map();
  for (const item of list) {
    const key = getKey ? getKey(item) : undefined;
    if (filterNull && (key === null || key === undefined || key === "")) continue;
    map.set(key, item);
  }
  return map;
}

export function toObjectBy(items, getKey, { filterNull = true } = {}) {
  const list = Array.isArray(items) ? items : [];
  const pairs = [];
  for (const item of list) {
    const key = getKey ? getKey(item) : undefined;
    if (filterNull && (key === null || key === undefined || key === "")) continue;
    pairs.push([key, item]);
  }
  return Object.fromEntries(pairs);
}

export function mergeById(
  baseItems,
  extraItems,
  { idKey = "id", prefer = "base" } = {},
) {
  const base = Array.isArray(baseItems) ? baseItems : [];
  const extra = Array.isArray(extraItems) ? extraItems : [];
  const map = new Map();

  if (prefer === "extra") {
    for (const item of base) {
      const id = item?.[idKey];
      if (id === null || id === undefined) continue;
      map.set(id, item);
    }
    for (const item of extra) {
      const id = item?.[idKey];
      if (id === null || id === undefined) continue;
      map.set(id, item);
    }
  } else {
    for (const item of extra) {
      const id = item?.[idKey];
      if (id === null || id === undefined) continue;
      map.set(id, item);
    }
    for (const item of base) {
      const id = item?.[idKey];
      if (id === null || id === undefined) continue;
      map.set(id, item);
    }
  }

  return Array.from(map.values());
}
